import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../locale';

const withTranslations = WrappedComponent => {

  class WithTranslations extends React.Component {

    constructor(props) {

      super(props);
      this.t = this.t.bind(this);
    }

    t(path, vars) {

      return translate(this.props.language, path, vars);
    }

    render() {

      return <WrappedComponent {...this.props} t={this.t} />;
    }
  }

  const mapStateToProps = state => ({ language: state.language });

  return connect(mapStateToProps, null)(WithTranslations);
};

export default withTranslations;
